var scope_0 = require('/sources/apps/zoe-portal/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2ccbbbb20521ad6b2aafa56e43cf70b5.js').default;
var scope_1 = require('/sources/apps/zoe-portal/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    